export default __webpack_public_path__ + "static/media/product-image-29.71c61829.jpg";